module.exports = __webpack_public_path__ + "img/Screen Shot 2021-04-18 at 6.54.18 PM.aadb0c74.png";